import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=3a30cbc2&scoped=true&lang=pug&"
import script from "./InfoTable.vue?vue&type=script&lang=js&"
export * from "./InfoTable.vue?vue&type=script&lang=js&"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=3a30cbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30cbc2",
  null
  
)

export default component.exports